import Vue from 'vue';

import 'normalize.css/normalize.css'; // A modern alternative to CSS resets

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/zh-CN'; // lang i18n
import VCharts from 'v-charts';

import '@/styles/index.scss'; // global css

import App from './App';
import router from './router';
import store from './store';

import ETable from '@/components/ETable'; //表格

import '@/icons'; // icon
import '@/permission'; // permission control

import { formatDate } from '@/utils/date';
import { exoprtFile, copy, accountAdd } from '@/utils/util';
import { debounce } from '@/directives/index';

import dayjs from 'dayjs';

Vue.use(ElementUI, { locale });
Vue.use(VCharts);
Vue.use(ETable);
Vue.filter('formatTime', (time) => {
  let date = new Date(time);
  return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
});



Vue.directive('debounce', debounce);

import ElDict from './components/ElDict';
Vue.component('ElDict', ElDict);

Vue.prototype.$exoprtFile = exoprtFile;
Vue.prototype.$accountAdd = accountAdd;
Vue.prototype.$copy = copy;
Vue.prototype.$dayjs = dayjs;

Vue.config.productionTip = false;

Vue._watchers = Vue.prototype._watchers = [];

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js